// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DatapointValueFromJSON(json) {
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'type': json['type'],
        'variationType': !exists(json, 'variationType') ? undefined : json['variationType'],
    };
}
export function DatapointValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'value': value.value,
        'type': value.type,
        'variationType': value.variationType,
    };
}
/**
* @export
* @enum {string}
*/
export var DatapointValueTypeEnum;
(function (DatapointValueTypeEnum) {
    DatapointValueTypeEnum["String"] = "string";
    DatapointValueTypeEnum["Number"] = "number";
    DatapointValueTypeEnum["Bool"] = "bool";
    DatapointValueTypeEnum["Date"] = "date";
    DatapointValueTypeEnum["Money"] = "money";
    DatapointValueTypeEnum["Variation"] = "variation";
    DatapointValueTypeEnum["Blob"] = "blob";
    DatapointValueTypeEnum["Area"] = "area";
    DatapointValueTypeEnum["Unit"] = "unit";
    DatapointValueTypeEnum["Metadata"] = "metadata";
})(DatapointValueTypeEnum || (DatapointValueTypeEnum = {}));
/**
* @export
* @enum {string}
*/
export var DatapointValueVariationTypeEnum;
(function (DatapointValueVariationTypeEnum) {
    DatapointValueVariationTypeEnum["String"] = "string";
    DatapointValueVariationTypeEnum["Number"] = "number";
    DatapointValueVariationTypeEnum["Bool"] = "bool";
    DatapointValueVariationTypeEnum["Date"] = "date";
    DatapointValueVariationTypeEnum["Money"] = "money";
})(DatapointValueVariationTypeEnum || (DatapointValueVariationTypeEnum = {}));
